import React, { useContext } from "react";
import { Grid, Card, CardContent, Typography } from "@mui/material";
import Resources from "./Resources";
import Announcements from "./Announcements";
import DistrictSchoolsList from "../../CcpDistricts/inc/DistrictSchoolsList";

const CcpDistrictDash = () => {
  return (
    <Grid container spacing={3} sx={{ padding: 3 }}>
      <Grid item xs={12} sx={{ display: "flex", justifyContent: "flex-end" }}>
        <Resources />
      </Grid>
      <Grid item xs={12} md={12}>
        <Announcements />
      </Grid>
      <Grid item xs={12} md={12}>
        <DistrictSchoolsList />
      </Grid>
    </Grid>
  );
};

export default CcpDistrictDash;
